@if (service.currentUser !== undefined && service.needTemplate === true) {
  <div style="height: 100%;">
    @if (service.isLoadingSpinner === true) {
      <div id="spinnerOverlay" >
        <app-spinner-overlay></app-spinner-overlay>
      </div>
    }
    <!-- <mat-divider *ngIf="service.currentUser.isAuthenticated === true"></mat-divider> -->
    @if (service.currentUser.isAuthenticated === true) {
      <mat-drawer-container class="mainDrawer" style="height: 100%;" [hasBackdrop]="false">
        <mat-drawer [mode]="service.miniSidebarOpen ? 'over' : 'side'" [opened]="true" [@slider]="!service.miniSidebarOpen? null : 'show'" class="slider">
          <app-sidebar></app-sidebar>
        </mat-drawer>
        <mat-drawer-content id="matDrawerContent" (mouseenter)="hideMouseHoverMiniSidebar()" style="margin: 0px;" [@sliderContent]="{value: (!service.miniSidebarOpen? null : 'show'), params: {pageWidth: getCurrentWidth()}}" class="slider">
          @if (service.currentUser.isAuthenticated === true) {
            <app-header style="height: 5%;"></app-header>
          }
          <div class="mat-drawer-inner-content" style="height: 88%;">
            <router-outlet></router-outlet>
          </div>
          @if (service.currentUser.isAuthenticated === true) {
            <app-footer style="height: 5%;"></app-footer>
          }
        </mat-drawer-content>
      </mat-drawer-container>
    }
    @if (service.currentUser.isAuthenticated === false) {
      <app-login style="height: 95%;"></app-login>
    }
    @if (service.currentUser.isAuthenticated === true) {
      <mat-divider></mat-divider>
    }
    @if (service.currentUser.isAuthenticated === false) {
      <app-footer style="height: 5%;"></app-footer>
    }
  </div>
}
@if (service.currentUser === undefined  && service.needTemplate === true) {
  <div>
    <svg class="spinner" viewBox="25 25 50 50">
      <style type="text/css">
        body {
        overflow: hidden;
      }
      circle {
      stroke: url(#MyGradient)
    }
  </style>
  <defs>
    <linearGradient id="MyGradient">
      <stop offset="0%" stop-color="#303c74" stop-opacity="1"/>
      <stop offset="50%" stop-color="#303c74" stop-opacity="0.5"/>
      <stop offset="75%" stop-color="#303c74" stop-opacity="0.3"/>
      <stop offset="80%" stop-color="#303c74" stop-opacity="0.2"/>
      <stop offset="85%" stop-color="#303c74" stop-opacity="0.1"/>
      <stop offset="90%" stop-color="#303c74" stop-opacity="0"/>
    </linearGradient>
  </defs>
  <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
</svg>
</div>
}
@if (service.needTemplate === false) {
  <div style="height: 100%;">
    @if (service.isLoadingSpinner === true) {
      <div id="spinnerOverlay" class="OverrideSpinnerOverlay">
        <app-spinner-overlay></app-spinner-overlay>
      </div>
    }
    <router-outlet></router-outlet>
  </div>
}
